import api from '../../config/axios.js';
import moment from 'moment';
import { isAuthenticated } from '@/services/authService';
import { normalizeAccessPages } from '@/utils/accessControl';
import { authenticatedLanding, apiError } from '@/services/registrationExperience';

const state = {
    trial: null,
    onboarding: null,
    id: '',
    name: "",
    cell_phone: "",
    commercial_phone: "",
    active: "",
    email: "",
    company_id: "",
    created_at: "",
    configurations: {},
    errorRegister: "",
    errorForgotPasswordSendEmail: "",
    configurationSftp: [],
    currentConfigurationSftp: {},
    usersList: [],
    allUsersList: [],
    currentDeleteUser: {},
    currentUpdateUser: {},
    operations: [],
    operation: null,
    loadedOperations: false,
    permissions: [],
    allowedPages: [],
    visibleUserIds: [],
    accessPages: [],
    rolesList: [],
    contacts: [],
    selectedContacts: [],
    sendForAll: true,
    selectedFile: null,
    qr_code: null,
    whatsapp_number: null,
    whatsapp_settings: null,
    whatsapp_templates: [],
}
const getters = {
    getTrial: state => state.trial,
    getOnboarding: state => state.onboarding,
    getId: state => state.id,
    getName: state => state.name,
    getPhone: state => state.phone,
    getBirthday: state => (state.birthday != null) ? moment(state.birthday).format('DD/MM/YYYY') : 'Não Informado',
    getActive: state => state.active,
    getEmail: state => state.email,
    getCompany_id: state => state.company_id,
    getCreatedAt: state => (state.created_at != null) ? moment(state.created_at).format('DD/MM/YYYY') : 'Não Informado',
    getConfigurations: state => state.configurations,
    getErrorRegister: state => state.errorRegister,
    getErrorForgotPasswordSendEmail: state => state.errorForgotPasswordSendEmail,
    getConfigurationSftp: state => state.configurationSftp,
    getCurrentConfigurationSftp: state => state.currentConfigurationSftp,
    getUsersList: state => state.usersList,
    getAllUsersList: state => state.allUsersList,
    getCurrentDeleteUser: state => state.currentDeleteUser,
    getCurrentUpdateUser: state => state.currentUpdateUser,
    getOperations: state => state.operations,
    getOperation: state => state.operation,
    getLoadedOperations: state => state.loadedOperations,
    getPermissions: state => state.permissions,
    getAllowedPages: state => state.allowedPages,
    getVisibleUserIds: state => state.visibleUserIds,
    getEmployeeMetricsScope: state => state.id
        ? JSON.stringify([state.company_id, state.id, [...new Set([state.id, ...state.visibleUserIds].map(Number))].sort((a, b) => a - b)])
        : '',
    getAccessPages: state => normalizeAccessPages(state.accessPages),
    getRolesList: state => state.rolesList,
    getContacts: state => state.contacts,
    getSelectedContacts: state => state.selectedContacts,
    getSendForAll: state => state.sendForAll,
    getSelectedFile: state => state.selectedFile,
    getQrCode: state => state.qr_code,
    getWhatsappNumber: state => state.whatsapp_number,
    getWhatsappSettings: state => state.whatsapp_settings,
    getWhatsappTemplates: state => state.whatsapp_templates,
}
const actions = {
    //RECEBENDO NOVO QR CODE VIA WEBSOCKET
    async receiveNewQrCodeWebsocket({ commit }, data){
        commit("setQrCode", data.qr_code);
    },
    async resetWhatsappNumber({commit}){
        commit("setWhatsappNumber", "");
    },
    // VERIFICANDO STATUS DO WHATSAPP
    async fetchStatusWhatsapp({ commit }){
        commit("setQrCode", "LOADING")
        await api.axios.get('/api/ura/whatsapp/status').catch((error) => {
            if(error.response && error.response.status == 404){
                commit("setQrCode", "NOT_FOUND");
                commit("setWhatsappNumber", "");
            } else {
                commit("setQrCode", "ERROR");
            }
        }).then(response => {
            if(response && response.data){
                commit("setWhatsappNumber", response.data.number);
                commit("setQrCode", response.data.qr_code);
            }
        });
    },
    // SALVANDO NÚMERO DO WHATSAPP
    async saveWhatsappNumber({ commit }, data){
        await api.axios.post('/api/ura/whatsapp/number', data).catch((error) => {
            if(error.response && error.response.status == 404){
                commit("setQrCode", "NOT_FOUND");
            } else {
                commit("setQrCode", "ERROR");
            }
        }).then(response => {
            if(response && response.data){
                window.location.reload();
            }
        });
    },
    //RESETANDO DISPARO MANUAL
    async resetManualDispatcher({ commit }, data){
        commit("setSelectedContacts", []);
        commit("setSendForAll", false);
        commit('setSelectedFile', null);
    },
    // BUSCANDO AS ROLES
    async setRolesList({ commit }){
        commit("resetLoadedOperation", false);
        await api.axios.get('/api/roles').catch(() => {
            commit("setRolesList", []);
        }).then(response => {
            if(response && response.data){
                commit("setRolesList", response.data);
            } else {
                commit("setRolesList", []);
            }
        });
    },
    // BUSCANDO AS OPERAÇÕES DO CLIENTE
    async setOperations({ commit }){
        commit("resetLoadedOperation", false);
        await api.axios.get('/api/operations').catch((error) => {
            if(error.response && error.response.data){
                commit("setOperations", []);
            }
        }).then(response => {
            if(response && response.data){
                commit("setOperations", response.data);
            } else {
                commit("setOperations", []);
            }
        });
    },
    // BUSCANDO UMA OPERAÇÃO ESPECÍFICA
    async setOperation({ commit }, id){
        await api.axios.get('/api/operation/'+id).catch((error) => {
            if(error.response && error.response.data){
                commit("setOperation", null);
            }
        }).then(response => {
            if(response && response.data){
                commit("setOperation", response.data);
            } else {
                commit("setOperation", null);
            }
        });
    },
    async setAuthenticatedUser({ commit }){
        await api.axios.get('/api/user').catch(() => {
            commit("setAuthenticatedUser", null);
        }).then(response => {
            if(response && response.data){
                commit("setAuthenticatedUser", response.data);
            }
        });
    },
    async setAccessControl({ commit }){
        await api.axios.get('/api/access-control').catch(() => {
            commit("setAccessControl", null);
        }).then(response => {
            if(response && response.data){
                commit("setAccessControl", response.data);
            }
        });
    },

    // REALIZANDO CRIAÇÃO DA EMPRESA/USUÁRIO
    async sendRegister({ commit }, obj){
        commit('setErrorRegister', '');
        try {
            const { data } = await api.axios.post('/api/register', obj);
            if (!data.token) throw new Error('Missing authentication token');
            localStorage.setItem('auth_token', data.token);
        } catch (error) {
            commit('setErrorRegister', apiError(error, 'Não foi possível criar sua conta. Tente novamente.'));
            return;
        }
        // Registration succeeded; a navigation failure must not encourage a second registration.
        let path = '/dashboard';
        try { path = await authenticatedLanding(); } catch (error) { path = '/dashboard'; }
        window.location.href = path;
    },
    // ENVIAR EMAIL DE ESQUECI MINHA SENHA
    async sendForgotPasswordSendEmail({ commit }, obj){
        await api.axios.post('/api/reset/password/email', {email: obj.email}).catch((error) => {
            if(error.response && error.response.data){
                commit("setErrorForgotPasswordSendEmail", error.response.data);
            }
        }).then(response => {
            if(response && response.status && response.status == 200){
                obj.router.push('/send-email-forgot-password');
            }
        });
    },
    // SETANDO ERRO EM VALIDAÇÕES FORGOT PASSWORD
    async setErrorForgotPasswordSendEmail({ commit }, message){
        commit("setErrorForgotPasswordSendEmail", message);
    },
    // REALIZANDO LOGIN
    async sendCreateSession(obj){
        await window.axios.post('/api/login', obj).catch(() => {
            console.log("tratar erro de login");
        }).then(response => {
            if(response && response.data && response.data.token != undefined){
                localStorage.setItem("auth_token", response.data.token);
                window.location.href = "/";
            }         
        });
    },
    async fetchWhatsappSettings({ commit }){
        const response = await api.axios.get('/api/whatsapp/settings');
        commit('setWhatsappSettings', response.data);
        if(response.data?.provider === 'cloud_api') commit('setWhatsappNumber', response.data.cloud?.display_phone_number || '');
        return response.data;
    },
    async selectWhatsappProvider({ dispatch }, selection){
        const payload = typeof selection === 'string' ? { provider: selection } : selection;
        await api.axios.put('/api/whatsapp/provider', payload);
        await dispatch('fetchWhatsappSettings');
        await dispatch('fetchConfigurations');
    },
    async saveWhatsappCloudCredentials({ dispatch }, data){
        await api.axios.put('/api/whatsapp/cloud/credentials', data);
        return dispatch('fetchWhatsappSettings');
    },
    async validateWhatsappCloud({ dispatch }){
        await api.axios.post('/api/whatsapp/cloud/validate');
        await dispatch('fetchWhatsappSettings');
        return dispatch('fetchWhatsappTemplates');
    },
    async startWhatsappCoexistenceSession(){
        const response = await api.axios.post('/api/whatsapp/cloud/coexistence/session');
        return response.data;
    },
    async completeWhatsappCoexistenceSession({ dispatch }, data){
        const response = await api.axios.post('/api/whatsapp/cloud/coexistence/complete', data);
        await dispatch('fetchWhatsappSettings');
        return response.data;
    },
    async selectWhatsappCoexistencePhone({ dispatch }, data){
        const response = await api.axios.post('/api/whatsapp/cloud/coexistence/select-phone', data);
        await dispatch('fetchWhatsappSettings');
        return response.data;
    },
    async checkWhatsappCoexistence({ dispatch }, data = {}){
        const response = await api.axios.post('/api/whatsapp/cloud/coexistence/check', data);
        await dispatch('fetchWhatsappSettings');
        return response.data;
    },
    async recordWhatsappCoexistenceDiagnostic(_, data){
        await api.axios.post('/api/whatsapp/cloud/coexistence/diagnostics', data);
    },
    async fetchWhatsappTemplates({ commit }){
        const response = await api.axios.get('/api/whatsapp/cloud/templates');
        commit('setWhatsappTemplates', response.data || []);
        return response.data;
    },
    async fetchChatWhatsappTemplates({ commit }){
        const response = await api.axios.get('/api/chat/templates/approved');
        commit('setWhatsappTemplates', response.data || []);
        return response.data;
    },
    async syncWhatsappTemplates({ commit }){
        const response = await api.axios.post('/api/whatsapp/cloud/templates/sync');
        commit('setWhatsappTemplates', response.data || []);
        return response.data;
    },
    async createWhatsappTemplate({ dispatch }, data){
        await api.axios.post('/api/whatsapp/cloud/templates', data);
        return dispatch('fetchWhatsappTemplates');
    },
    async deleteWhatsappTemplate({ dispatch }, id){
        await api.axios.delete(`/api/whatsapp/cloud/templates/${id}`);
        return dispatch('fetchWhatsappTemplates');
    },
    // REALIZAR LOGOFF
    async logoffSession() {
        await api.axios.post('/api/logout').catch(function(){
            return null;
        }).then(function(){
            localStorage.removeItem("auth_token");
            localStorage.removeItem("selected_operation_id");
            sessionStorage.removeItem("billingRestrictionMessage");
            window.location.href = "/login";
        });
    },
    // RECUPERANDO CONFIGURAÇÕES SFTP
    async setConfigurationSftp({commit}) {
        await api.axios.get('/api/configurations/sftp').catch(function(){
            console.log("erro ao recuperar configurações sftp");
        }).then(function(response){
            if(response && response.status && response.status == 200){
                commit('setConfigurationSftp', response.data);
            }
        });
    },
    // SALVANDO A NOVA CONFIGURAÇÃO DE UPLOAD VIA SFTP
    async saveConfigurationSftp({commit}, obj) {
        await api.axios.post('/api/save/configurations/sftp', obj).catch(function(error){
            console.log("erro", error);
        }).then(function(response){
            commit("savedConfigurationSftp", response.data);
        });
    },
    async setContacts({ commit }, client) {
        try {
            const response = await api.axios.get(
            `/api/search/client/phone/${encodeURIComponent(client)}`
            );

            commit('setContacts', response.data || []);
        } catch (error) {
            if (error.response && error.response.status === 404) {
            // 👇 comportamento correto para autocomplete
            commit('setContacts', []);
            return;
            }

            console.error('Erro real ao buscar contatos:', error);
            commit('setContacts', []);
        }
    },
    async setSelectedContacts({ commit }, clients){
        commit('setSelectedContacts', clients);
    },
    // SETANDO CHECKED OU NÃO PARA ENVIAR MENSAGENS A TODOS OS CONTATOS
    async setSendForAll({ commit }, check){
        commit('setSendForAll', check);
    },
    // MANIPULANDO O ARQUIVO CSV QUE SERÁ ENVIADO AO BACKEND
    async setSelectedFile({ commit }, file){
        commit('setSelectedFile', file);
    },
    // BUSCAR CONFIGURAÇÕES
    async setConfiguration({ commit }) {
        if(await isAuthenticated()){
            await api.axios.get('/api/configurations').catch(function(error){
                if(error && error.response && error.response.status === 403){
                    const responseData = error.response.data || {};

                    if(responseData.company_active === false){
                        const message = responseData.message || "Cadastro inativo. Regularize o pagamento pendente para continuar usando o sistema.";
                        sessionStorage.setItem("billingRestrictionMessage", message);
                        window.dispatchEvent(new CustomEvent("billingRestrictionMessageChanged", { detail: message }));
                    }

                    return;
                }
                if(error && error.response && error.response.status === 401 && window.location.pathname != "/home" && window.location.pathname != "/login" && window.location.pathname != "/" && window.location.pathname != "/register" && window.location.pathname != "/forgot-password" && window.location.pathname != "/send-email-forgot-password" && window.location.pathname != "/terms" && window.location.pathname != "/privacy-policy"){
                    window.location.href = "/login";
                }
            }).then(function(response){
                if(response && response.status == 200){
                    sessionStorage.removeItem("billingRestrictionMessage");
                    window.dispatchEvent(new CustomEvent("billingRestrictionMessageChanged", { detail: "" }));
                    commit('setConfiguration', response.data);
                }
            });
        } else {
            if(window.location.pathname != "/home" && window.location.pathname != "/login" && window.location.pathname != "/" && window.location.pathname != "/register" && window.location.pathname != "/forgot-password" && window.location.pathname != "/send-email-forgot-password" && window.location.pathname != "/terms" && window.location.pathname != "/privacy-policy"){
                window.location.href = "/login";
            }
        }
    },
    reloadData({ commit }, data) {
        commit('sendCreateSession', data);
    },
    setNewToken({ commit }, data){
        commit("setNewToken", data);
    },
    setCurrentConfigurationSftp({ commit }, data){
        commit("setCurrentConfigurationSftp", data);
    },
    // LISTANDO USUÁRIOS
    async setUsersList({ commit }){
        await api.axios.get('/api/users').catch(() => {
            commit("setUsersList", []);
        }).then((response) => {
            if(response && response.data){
                commit("setUsersList", response.data);
            }
        });
    },
    // LISTANDO TODOS OS USUÁRIOS
    async setAllUsersList({ commit }){
        await api.axios.get('/api/all-users').catch(() => {
            commit("setAllUsersList", []);
        }).then((response) => {
            if(response && response.data){
                commit("setAllUsersList", response.data);
            }
        });
    },
    async setCurrentDeleteUser({ commit }, data){
        commit('setCurrentDeleteUser', data);
    },
    async setCurrentUpdateUser({ commit }, data){
        commit('setCurrentUpdateUser', data);
    }
}
const mutations = {
    // SETANDO INFORMACOES DE LOGIN
    sendCreateSession: function(state, data){
        state.id = data.id;
        state.name = data.name;
        state.cell_phone = data.cell_phone;
        state.commercial_phone = data.commercial_phone;
        state.active = data.active;
        state.email = data.email;
        state.company_id = data.company_id;
        state.created_at = data.created_at;
    },
    //REALIZADO O SALVAMENTO DA CONFIGURAÇÃO SFTP
    savedConfigurationSftp: function(){
        // state.configurations = data;
    },
    //BUSCANDO CONFIGURAÇÕES ATUAIS
    setConfiguration: function(state, data){
        state.configurations = data;
    },
    setNewToken: function(state, data){
        state.configurations.companyToken = data;
    },
    setTokenSession: function(){
        window.location.href = "/";
    },
    setErrorRegister: function(state, data){
        state.errorRegister = data;
    },
    setErrorForgotPasswordSendEmail: function(state, data){
        state.errorForgotPasswordSendEmail = data;
    },
    setConfigurationSftp: function(state, data){
        state.configurationSftp = data;
    },
    setCurrentConfigurationSftp: function(state, data){
        state.currentConfigurationSftp = data;
    },
    setUsersList: function(state, data){
        state.usersList = data;
    },
    setAllUsersList: function(state, data){
        state.allUsersList = data;
    },
    setCurrentDeleteUser: function(state, data){
        state.currentDeleteUser = data;
    },
    setCurrentUpdateUser: function(state, data){
        state.currentUpdateUser = data;
    },
    resetLoadedOperation: function(state, data){
        state.loadedOperations = data;
    },
    setOperations: function(state, data){

        if(data.length > 0){
            state.loadedOperations = true;
            
            if(!localStorage.getItem("selected_operation_id")){
                localStorage.setItem("selected_operation_id", data[0].id);
            } else if(!data.find(op => op.id == localStorage.getItem("selected_operation_id"))){
                localStorage.setItem("selected_operation_id", data[0].id);
            }
        }

        state.operations = data;

    },
    setOperation: function(state, data){
        state.operation = data;
    },
    setPermissions: function(state, data){
        if(data.permissions){
            state.permissions = data.permissions;
        }
    },
    setAuthenticatedUser: function(state, data){
        state.trial = data?.trial || null;
        state.onboarding = data?.onboarding || null;
        if(!data){
            state.id = '';
            state.company_id = '';
            state.allowedPages = [];
            state.visibleUserIds = [];
            return;
        }

        state.id = data.id || state.id;
        state.name = data.name || state.name;
        state.cell_phone = data.cell_phone || state.cell_phone;
        state.commercial_phone = data.commercial_phone || state.commercial_phone;
        state.active = data.active !== undefined ? data.active : state.active;
        state.email = data.email || state.email;
        state.company_id = data.company_id || state.company_id;
        state.created_at = data.created_at || state.created_at;
        state.allowedPages = Array.isArray(data.allowed_pages) ? data.allowed_pages : [];
        state.visibleUserIds = Array.isArray(data.visible_user_ids) ? data.visible_user_ids : [];
    },
    setAccessControl: function(state, data){
        if(!data){
            state.accessPages = [];
            return;
        }

        state.accessPages = Array.isArray(data.pages) ? data.pages : [];
        state.allowedPages = Array.isArray(data.allowed_pages) ? data.allowed_pages : state.allowedPages;
        state.visibleUserIds = Array.isArray(data.visible_user_ids) ? data.visible_user_ids : state.visibleUserIds;
    },
    setRolesList: function(state, data){
        state.rolesList = data;
    },
    setContacts: function(state, data){
        state.contacts = data;
    },
    setSelectedContacts: function(state, data){
        state.selectedContacts = data;
    },
    setSendForAll: function(state, data){
        state.sendForAll = data;
    },
    setSelectedFile: function(state, file){
        state.selectedFile = file;
    },
    setQrCode: function(state, qr_code){
        state.qr_code = qr_code;
    },
    setWhatsappNumber: function(state, whatsapp_number){
        state.whatsapp_number = whatsapp_number;
    },
    setWhatsappSettings: function(state, settings){
        state.whatsapp_settings = settings;
    },
    setWhatsappTemplates: function(state, templates){
        state.whatsapp_templates = templates;
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
